<ng-container *ngIf="errors && errors['required']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    <ng-content></ng-content>
  </span>
  <br>
</ng-container>

<ng-container *ngIf="errors && errors['messageError']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    {{ errors['messageError'] }}
  </span>
</ng-container>

<ng-container *ngIf="errors && errors['max']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    El número máximo de horas permitidas es {{ errors['max'].max | number }}
  </span>
</ng-container>
<ng-container *ngIf="errors && errors['min']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    El número minímo de horas permitido es {{ errors['min'].min | number }}
  </span>
</ng-container>

<ng-container *ngIf="errors && errors['minDate']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    La fecha mínima permitida es {{ errors['minDate'].min | date:'dd/MM/yyyy'  }}.
  </span><br>
</ng-container>

<ng-container *ngIf="errors && errors['maxDate']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    La fecha máxima permitida es {{ errors['maxDate'].max | date:'dd/MM/yyyy'  }}.
  </span>
</ng-container>

<ng-container *ngIf="errors && errors['invalidRange']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    La fecha no esta permitida (Fuera de rango)
  </span><br>
</ng-container>

<ng-container *ngIf="errors && errors['minlength']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    Mínimo {{ errors['minlength'].requiredLength }} caracteres.
  </span>
</ng-container>

<ng-container *ngIf="errors && errors['maxlength']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    Máximo {{ errors['maxlength'].requiredLength }} caracteres.
  </span>
</ng-container>

<ng-container *ngIf="errors && errors['pattern']">

  <ng-container *ngIf="compareRegex(errors['pattern'].requiredPattern, cellPhone)">
    <span class="msn-error--inline is-inactive font-12 color-red">
      Sólo debe contener números y empezar por 3.
    </span>
  </ng-container>  
  <ng-container *ngIf="compareRegex(errors['pattern'].requiredPattern, validateEmail)">
    <span class="msn-error--inline is-inactive font-12 color-red">
      Ingrese un Correo Electrónico válido.
    </span>
  </ng-container>

  <ng-container *ngIf="compareRegex(errors['pattern'].requiredPattern, validateExt)">
    <span class="msn-error--inline is-inactive font-12 color-red">
      Sólo se permiten archivos de Excel.
    </span>
  </ng-container>

  <ng-container *ngIf="compareRegex(errors['pattern'].requiredPattern, numberPattern)">
    <span class="msn-error--inline is-inactive font-12 color-red">
      Sólo debe contener números.
    </span>
  </ng-container>
  <ng-container *ngIf="compareRegex(errors['pattern'].requiredPattern, numberLettersPattern)">
    <span class="msn-error--inline is-inactive font-12 color-red">
      Sólo debe contener números y letras.
    </span>
  </ng-container>
  <ng-container *ngIf="compareRegex(errors['pattern'].requiredPattern, onlyLetters)">
    <span class="msn-error--inline is-inactive font-12 color-red">
      Sólo debe contener letras.
    </span>
  </ng-container>
  <ng-container *ngIf="compareRegex(errors['pattern'].requiredPattern, onlyLettersEspecialCharts)">
    <span class="msn-error--inline is-inactive font-12 color-red">
      Sólo debe contener letras
    </span>
  </ng-container>
  <ng-container *ngIf="compareRegex(errors['pattern'].requiredPattern, validateAddress)">
    <span class="msn-error--inline is-inactive font-12 color-red">
      Ingrese una Dirección válida. Ej: KR 26Sur 60 25 ó CL 38A Bis Sur 3A 18 Este
    </span>
  </ng-container>
  <ng-container *ngIf="errors && errors['mustMatch']">
    <span class="msn-error--inline is-inactive font-12 color-red">
      Las contraseñas no coinciden
    </span>
  </ng-container>
</ng-container>

<ng-container *ngIf="errors && errors['salarioMinimoConyuge']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    El salario no debe ser menor a {{ errors["salarioMinimoConyuge"].min | number}}
  </span><br>
</ng-container>

<ng-container *ngIf="errors && errors['salarioMaximoConyuge']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    El salario no debe ser mayor a {{ errors["salarioMaximoConyuge"].max | number}}
  </span>
</ng-container>

<ng-container *ngIf="errors && errors['isSevenCero']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    Telefono Invalido
  </span>
</ng-container>

<ng-container *ngIf="errors && errors['addressInvalid']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    Dirección inválida. Ej: CL 38A BIS SUR 3A 18 ESTE
  </span>
</ng-container>

<ng-container *ngIf="errors && errors['pattern']">
  <ng-container
    *ngIf="compareRegex(errors['pattern'].requiredPattern, caracterValido)"
  >
    <span class="msn-error--inline is-inactive font-12 color-red">
      no se admiten caracteres especiales a excepcion de - o #
    </span>
  </ng-container>
</ng-container><ng-container *ngIf="errors && errors['pattern']">
  <ng-container
    *ngIf="compareRegex(errors['pattern'].requiredPattern, caracterValido)"
  >
    <span class="msn-error--inline is-inactive font-12 color-red">
      no se admiten caracteres especiales a excepcion de - o #
    </span>
  </ng-container>
</ng-container>

<ng-container *ngIf="errors && errors['documentoIgualTrabajador']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    El documento no puede ser el mismo que el del Titular.
  </span>
</ng-container>

<ng-container *ngIf="errors && errors['documentoIgualConyuge']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    El documento no puede ser el mismo que el del cónyuge.
  </span>
</ng-container>

<ng-container *ngIf="errors && errors['documentoIgualBeneficiario']">
  <span class="msn-error--inline is-inactive font-12 color-red">
    Ya estas afiliando este beneficiario.
  </span>
</ng-container>